// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var storage = localStorage;

var defaultSensationsContractAddress = "0x84D7d0F4A74930A26bD04789ffFbC573E54dFaBc";

var defaultUrl = "sepolia";

var defaultConfig = {
  sensationsContractAddress: defaultSensationsContractAddress,
  networkUrl: defaultUrl
};

var configStorageKey = "config";

async function registerPeriodicNotification(param) {
  var swRegistration = await navigator.serviceWorker.ready;
  swRegistration.periodicSync.register("sensum-heartbeat", {
        minInterval: 30000
      });
}

async function syncNotificationConfig(newConfig) {
  var swRegistration = await navigator.serviceWorker.ready;
  var sw = swRegistration.active;
  if (sw !== undefined) {
    Caml_option.valFromOption(sw).postMessage(newConfig);
    return ;
  }
  
}

function readConfig(param) {
  return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.null_to_opt(storage.getItem(configStorageKey)), (function (prim) {
                    return JSON.parse(prim);
                  })), defaultConfig);
}

function useConfig(param) {
  var match = React.useState(function () {
        return readConfig(undefined);
      });
  var setConfig = match[1];
  var saveConfig = function (networkUrl, sensationsContractAddress) {
    if (networkUrl === "" || sensationsContractAddress === "") {
      return {
              TAG: /* Error */1,
              _0: "Empty settings not allowed"
            };
    }
    var updatedConfig = {
      sensationsContractAddress: sensationsContractAddress,
      networkUrl: networkUrl
    };
    var maybeUpdatedConfigSerialized = JSON.stringify(updatedConfig);
    if (maybeUpdatedConfigSerialized !== undefined) {
      storage.setItem(configStorageKey, maybeUpdatedConfigSerialized);
      Curry._1(setConfig, (function (param) {
              return updatedConfig;
            }));
      return {
              TAG: /* Ok */0,
              _0: undefined
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "Could not serialize updated config"
            };
    }
  };
  return [
          match[0],
          saveConfig
        ];
}

export {
  storage ,
  defaultSensationsContractAddress ,
  defaultUrl ,
  defaultConfig ,
  configStorageKey ,
  registerPeriodicNotification ,
  syncNotificationConfig ,
  readConfig ,
  useConfig ,
}
/* storage Not a pure module */
